export const nl = {
  common: {
    language: 'Taal',
    login: 'Inloggen',
    signup: 'Registreren',
    logout: 'Uitloggen',
    dashboard: 'Dashboard',
    or: 'of',
    learnMore: 'Lees meer',
    back: 'Terug',
    save: 'Opslaan',
    cancel: 'Annuleren',
    delete: 'Verwijderen',
    edit: 'Bewerken',
    loading: 'Laden...',
    error: 'Er is een fout opgetreden',
    success: 'Bewerking geslaagd'
  },
  nav: {
    services: 'Onze Diensten',
    history: 'Onze Geschiedenis',
    fleet: 'Onze Vloot',
    team: 'Ons Team',
    contact: 'Contact',
    becomeDriver: 'Word Chauffeur',
    about: 'Over Ons'
  },
  dashboard: {
    driver: 'Chauffeur',
    passenger: 'Passagier',
    stats: 'Statistieken',
    trips: 'Ritten',
    upcomingTrips: 'Aankomende ritten',
    tripHistory: 'Ritgeschiedenis',
    profile: 'Mijn profiel',
    payment: 'Betaling',
    noTrips: 'Geen aankomende ritten',
    noTripsDescription: 'U heeft momenteel geen geplande ritten.'
  },
  auth: {
    email: 'E-mail',
    password: 'Wachtwoord',
    confirmPassword: 'Bevestig wachtwoord',
    forgotPassword: 'Wachtwoord vergeten?',
    noAccount: 'Heeft u nog geen account?',
    haveAccount: 'Heeft u al een account?',
    firstName: 'Voornaam',
    lastName: 'Achternaam',
    phone: 'Telefoon',
    emailPlaceholder: 'Uw e-mailadres',
    passwordPlaceholder: 'Uw wachtwoord',
    loginToBookTrips: 'Log in om uw ritten te boeken',
    loginToAccessDashboard: 'Log in voor toegang tot uw dashboard',
    continueWithGoogle: 'Doorgaan met Google',
    continueWithApple: 'Doorgaan met Apple',
    termsAgreement: 'Door in te loggen, gaat u akkoord met onze',
    termsOfUse: 'Gebruiksvoorwaarden',
    andOur: 'en ons',
    privacyPolicy: 'Privacybeleid'
  },
  booking: {
    pickup: 'Ophaallocatie',
    dropoff: 'Bestemming',
    date: 'Datum',
    time: 'Tijd',
    passengers: 'Passagiers',
    book: 'Boeken',
    bookNow: 'Nu boeken'
  },
  status: {
    pending: 'In afwachting',
    accepted: 'Geaccepteerd',
    ongoing: 'Bezig',
    completed: 'Voltooid',
    cancelled: 'Geannuleerd'
  },
  app: {
    home: 'Thuis',
    book: 'Reserveren',
    activity: 'Activiteit',
    profile: 'Profiel',
    favorites: 'Favoriete adressen',
    addFavorite: 'Adres toevoegen',
    useAddress: 'Dit adres gebruiken',
    noFavorites: 'Geen favoriete adressen',
    settings: 'Instellingen',
    preferences: 'Voorkeuren',
    notifications: 'Meldingen',
    darkMode: 'Donkere modus',
    language: 'Taal',
    account: 'Account',
    paymentMethods: 'Betaalmethoden',
    privacy: 'Privacy',
    support: 'Ondersteuning',
    help: 'Hulp'
  },
  home: {
    hero: {
      title: 'Welkom bij',
      desc: 'De beste transportervaring voor al uw verplaatsingen. Professionele, punctuele en comfortabele service.'
    },
    booking: {
      type: {
        ride: 'Een rit',
        hourly: 'Per uur'
      },
      input: {
        origin: 'Vertrekadres',
        destination: 'Bestemmingsadres',
        departureDate: 'Vertrekdatum',
        departureTime: 'Vertrektijd',
        returnDate: 'Retourdatum',
        returnTime: 'Retourtijd'
      },
      action: {
        addReturn: 'RETOUR TOEVOEGEN',
        calculating: 'BEREKENEN...',
        search: 'ZOEKEN'
      },
      error: {
        departureMustBeFuture: 'De vertrektijd moet in de toekomst liggen',
        returnMustBeAfterDeparture: 'De retourdatum kan niet voor de vertrekdatum liggen',
        selectValidAddresses: 'Selecteer geldige vertrek- en aankomstadressen',
        cannotCalculateRoute: 'Kan de route niet berekenen. Probeer het opnieuw.',
        addressesRequired: 'Voer de vertrek- en aankomstadressen in'
      },
      info: {
        distance: 'Afstand',
        duration: 'Geschatte duur',
        price: 'Geschatte prijs'
      }
    },
    services: {
      title: 'Onze Diensten',
      subtitle: 'Transportoplossingen afgestemd op uw behoeften',
      description: 'Bij TaxiMoove zetten we ons in om hoogwaardige transportdiensten te bieden die zijn afgestemd op uw behoeften. Ons wagenpark van moderne voertuigen en professionele chauffeurs staan tot uw beschikking om u een comfortabele, veilige en punctuele transportervaring te bieden.',
      book: 'Nu boeken'
    },
    about: {
      title: 'Waarom kiezen voor TaxiMoove?',
      description: 'Bij TaxiMoove onderscheiden we ons door onze toewijding aan excellentie en klantenservice. Onze unieke aanpak combineert professionaliteit, innovatie en personalisatie om u een onvergelijkbare transportervaring te bieden.',
      details: {
        premium: {
          title: 'Premium Service',
          description: 'Onze professionele chauffeurs worden zorgvuldig geselecteerd en getraind om u service van superieure kwaliteit te bieden. Hoffelijk, punctueel en attent, zij passen zich aan uw specifieke behoeften aan.'
        },
        security: {
          title: 'Gegarandeerde Veiligheid',
          description: 'Uw veiligheid is onze absolute prioriteit. Al onze voertuigen worden regelmatig onderhouden en uitgerust met de nieuwste veiligheidstechnologieën. Onze chauffeurs volgen continue trainingen op het gebied van verkeersveiligheid.'
        },
        punctuality: {
          title: 'Stiptheid',
          description: 'We begrijpen dat uw tijd kostbaar is. Daarom verbinden we ons ertoe altijd stipt te zijn. Ons realtime volgsysteem stelt ons in staat u precies te informeren over de aankomst van uw chauffeur.'
        },
        personalization: {
          title: 'Gepersonaliseerde Service',
          description: 'Elke klant is uniek, en we passen onze service aan uw specifieke behoeften aan. Of het nu gaat om een regelmatige of incidentele reis, we creëren een oplossing op maat.'
        },
        price: {
          title: 'Transparante Tarieven',
          description: 'Geen verrassingen met onze tarieven. We hanteren duidelijke en transparante prijzen, zonder verborgen kosten. Met onze online prijscalculator kunt u de exacte kosten van uw reis weten vóór het boeken.'
        },
        region: {
          title: 'Volledige Dekking',
          description: 'We bedienen de hele regio met een vloot van moderne en comfortabele voertuigen. Of u nu in de stad bent of in de buitenwijken, we zijn er om u overal te begeleiden.'
        }
      },
      footer: {
        title: 'Kwaliteitsverbintenis',
        description: 'Bij TaxiMoove verbinden we ons ertoe u een uitzonderlijke transportervaring te bieden. Klanttevredenheid is onze prioriteit, en we blijven innoveren om onze diensten te verbeteren.'
      }
    },
    contact: {
      title: 'Klaar om uw reis te boeken?',
      description: 'Ons team staat klaar om uw specifieke transportbehoeften te bespreken en u een gepersonaliseerde oplossing voor te stellen. Aarzel niet om contact met ons op te nemen voor een gratis offerte of om een reservering te maken.',
      action: 'Neem contact met ons op'
    }
  },
  services: {
    hero: {
      title: 'Onze Premium Transportdiensten',
      description: 'Ontdek ons complete aanbod aan transportdiensten aangepast aan al uw behoeften. Van dagelijkse ritten tot luchthaven transfers, wij garanderen u een kwaliteitsservice.'
    },
    standard: {
      title: 'Standaard Transport',
      description: 'Comfortabele en betrouwbare transportservice voor uw dagelijkse of occasionele ritten.',
      descriptionLong: 'Premium taxiservice voor al uw dagelijkse verplaatsingen. Of het nu gaat om een zakelijke afspraak, een speciaal evenement of gewoon een ritje door de stad, onze standaard vervoersservice garandeert comfort, stiptheid en professionaliteit.',
      features: [
        'Moderne en comfortabele voertuigen',
        'Professionele chauffeurs',
        'Service beschikbaar 24/7'
      ]
    },
    airport: {
      title: 'Luchthaven Transfers',
      description: 'Gespecialiseerde transferservice voor uw ritten van en naar luchthavens.',
      descriptionLong: 'Transferservice van en naar luchthavens in België. We volgen uw vluchtstatus om een tijdige ophaalservice te garanderen, zelfs bij vertragingen.',
      features: [
        'Realtime vluchtvolging',
        'Assistentie met bagage',
        'Familievriendelijke voertuigen'
      ]
    },
    parcel: {
      title: 'Pakketvervoer',
      description: 'Snelle en veilige bezorgservice voor uw pakketten en belangrijke documenten.',
      descriptionLong: 'Snelle en veilige bezorgservice voor uw pakketten en belangrijke documenten. Wij zorgen voor de ophaling en levering van uw zendingen binnen de best mogelijke termijnen.',
      features: [
        'Realtime tracking',
        'Express bezorging',
        'Koerierdienst'
      ]
    },
    cta: {
      title: 'Klaar om uw rit te reserveren?',
      description: 'Profiteer nu van onze premium services. Reserveer met een paar klikken en reis met gemoedsrust.',
      button: 'Nu reserveren'
    }
  },
  about: {
    title: 'Over TaxiMoove',
    ourStory: {
      title: 'Ons Verhaal',
      description: 'Opgericht in 2020, TaxiMoove is ontstaan uit de visie om een premium transportservice te bieden die comfort, veiligheid en stiptheid combineert. Onze toewijding aan excellentie heeft ons in staat gesteld een belangrijke speler te worden in het privévervoer in Brussel.'
    },
    ourVehicles: {
      title: 'Ons Wagenpark',
      description: 'Ontdek onze verscheidenheid aan premium voertuigen, ontworpen om aan al uw transportbehoeften te voldoen met comfort en stijl.'
    },
    ourTeam: {
      title: 'Ons Team',
      description: 'Maak kennis met de gepassioneerde mensen die dag na dag uitzonderlijke kwaliteitsservice mogelijk maken.'
    },
    ourValues: {
      title: 'Onze Waarden',
      subtitle: 'Deze principes sturen elk van onze acties en vormen de kern van onze toewijding aan u',
      values: {
        premium: {
          title: 'Premium Klantenservice',
          description: 'Uw tevredenheid is onze absolute prioriteit. We streven ernaar uw verwachtingen bij elke reis te overtreffen met gepersonaliseerde en attente service.'
        },
        professional: {
          title: 'Professionaliteit',
          description: 'Onze chauffeurs zijn ervaren professionals, getraind om u service van de hoogste kwaliteit te bieden met respect voor veiligheidsnormen.'
        },
        excellence: {
          title: 'Excellentie',
          description: 'We streven naar excellentie in elk aspect van onze service, van de netheid van onze voertuigen tot de hoffelijkheid van onze chauffeurs en de betrouwbaarheid van onze ritten.'
        }
      }
    },
    learnMore: 'Meer weten'
  },
  ourStory: {
    title: 'Ons Verhaal',
    content: [
      'TaxiMoove is ontstaan uit de ontmoeting en vriendschap tussen twee gepassioneerde ingenieurs, Elias en Moukrim, die een gemeenschappelijke visie delen: het opnieuw uitvinden van stedelijke vervoersdiensten om ze eerlijker, milieuvriendelijker en efficiënter te maken.',
      'Met hun complementaire achtergronden — Elias, natuurkundig ingenieur gespecialiseerd in fotonica van de ULB, en Moukrim, elektromechanisch ingenieur gespecialiseerd in transport en voertuigen van de VUB — hebben ze hun expertise gebundeld om een alternatief te creëren voor traditionele diensten dat tegemoetkomt aan hedendaagse uitdagingen van stedelijke mobiliteit.',
      'Hun verhaal is er een van een idee dat rijpte met de tijd, een vriendschap die taalkundige en culturele verschillen overstijgt, en een gedeelde ambitie om een positieve impact op de maatschappij te creëren.'
    ],
    timeline: {
      title: 'Ons Traject',
      times: [
        {
          title: 'De Ontmoeting',
          content: 'Elias van de ULB en Moukrim van de VUB, twee masterstudenten ingenieurswetenschappen, ontmoeten elkaar. Ondanks verschillende achtergronden - Elias in natuurkunde gespecialiseerd in fotonica en Moukrim in elektromechanica gespecialiseerd in transport en voertuigen - ontdekken ze dat ze dezelfde ambitie delen om ecologische en duurzame meerwaarde aan de maatschappij te brengen.'
        },
        {
          title: 'De Vaststelling',
          content: 'Als regelmatige gebruikers van vervoersdiensten stellen Elias en Moukrim vast dat bestaande oplossingen suboptimaal zijn - zowel voor klanten als voor chauffeurs en het milieu. Een idee begint te ontkiemen.'
        },
        {
          title: 'Het Begin van het Avontuur',
          content: 'Moukrim zet de stap en investeert in de aankoop van zijn eerste taxi\'s. Overtuigd van het potentieel van hun gedeelde visie, neemt hij opnieuw contact op met Elias om samen het idee uit te werken dat ze jaren eerder hadden geschetst.',
          time: 'Feb. 2024'
        },
        {
          title: 'De Geboorte van TaxiMoove',
          content: 'Elias en Moukrim bundelen hun complementaire vaardigheden - de ene Franstalig opgeleid aan de ULB, de andere Nederlandstalig afgestudeerd aan de VUB. Deze alliantie symboliseert de geest van TaxiMoove zelf: de convergentie van verschillende perspectieven om een efficiëntere en inclusievere oplossing te creëren.',
          time: 'Maart 2024'
        },
        {
          title: 'Vandaag',
          content: 'TaxiMoove biedt een modern model van vervoersdienst, afgestemd op zijn oprichtingswaarden: concurrerende prijzen voor gebruikers, eerlijke commissies voor chauffeurs, minder vervuilende voertuigen, efficiëntie op het niveau van reserveringen en service-excellentie op alle aspecten.',
        }
      ]
    }
  },
  ourValues: {
    title: 'Onze Waarden',
    description: 'Bij TaxiMoove sturen onze oprichtingswaarden elke actie en beslissing die we nemen, en weerspiegelen ze de visie van onze medeoprichters Elias en Moukrim.',
    values: {
      ecology: {
        title: 'Ecologische Duurzaamheid',
        content: 'We zetten ons in om de milieu-impact van stedelijk vervoer te verminderen door de voorkeur te geven aan minder vervuilende voertuigen en milieubewuste rijpraktijken.'
      },
      equity: {
        title: 'Rechtvaardigheid',
        content: 'We geloven in een evenwichtig economisch model dat concurrerende prijzen biedt aan gebruikers terwijl we eerlijke en transparante commissies garanderen aan onze partnerchauffeurs.'
      },
      innovation: {
        title: 'Innovatie',
        content: 'Voortkomend uit ingenieursopleiding passen we onze expertise toe om technologische oplossingen te ontwikkelen die elk aspect van de vervoersdienst optimaliseren.'
      },
      excellence: {
        title: 'Excellentie',
        content: 'We streven naar excellentie in elk detail: van de efficiëntie van ons reserveringssysteem tot de kwaliteit van onze voertuigen, inclusief de professionaliteit van onze chauffeurs.'
      },
    }
  },
  vehicle: {
    passengers: 'passagiers',
    luggages: 'bagage',
    skodaSuperbDesc: 'Comfortabele en economische sedan, perfect voor stedelijke en zakelijke verplaatsingen.',
    toyotaPriusDesc: 'Milieuvriendelijk hybride voertuig met uitstekend comfort voor al uw stadsreizen.',
    mercedesEDesc: 'Luxe sedan voor uw zakenreizen of speciale evenementen.',
    mercedesVDesc: 'Ruime bus ideaal voor groepen en families met veel bagage.',
    features: {
      leather: 'Lederen interieur',
      clim: 'Airconditioning',
      wifi: 'Gratis WiFi',
      usb: 'USB-oplader',
      baby: 'Babyzitje beschikbaar',
      ecolo: 'Milieuvriendelijk',
      cardPayment: 'Betaling met kaart',
      premium: 'Premium service',
      wheelchair: 'Rolstoeltoegankelijke ruimte',
      group: 'Perfect voor groepen'
    }
  },
  ourVehicles: {
    title: 'Ons Wagenpark',
    description: 'TaxiMoove beschikt over een gevarieerd wagenpark om aan al uw transportbehoeften te voldoen. Onze voertuigen zijn recent, regelmatig onderhouden en bestuurd door professionele chauffeurs.',
    why: 'Waarom kiezen voor ons wagenpark',
    values: {
      recent: {
        title: 'Recente voertuigen',
        content: 'Ons wagenpark bestaat uitsluitend uit recente voertuigen (minder dan 3 jaar oud) om u comfort en betrouwbaarheid te garanderen.'
      },
      maintenance: {
        title: 'Regelmatig onderhoud',
        content: 'Al onze voertuigen worden zorgvuldig onderhouden en schoongemaakt voor elke rit om u een onberispelijke ervaring te bieden.'
      },
      equipment: {
        title: 'Premium uitrusting',
        content: 'Gratis WiFi, waterflessen, telefoonopladers... Wij denken aan alles om uw reis zo aangenaam mogelijk te maken.'
      }
    }
  },
  team: {
    cofounder: 'Medeoprichter',
	driver: 'Driver',
    eliasDesc: 'Elias heeft TaxiMoove mede opgericht met een duidelijke visie: superieure transportdiensten aanbieden met focus op klanttevredenheid.',
    moukrimDesc: 'Moukrim houdt toezicht op alle dagelijkse activiteiten en zorgt voor perfecte coördinatie tussen onze chauffeurs en onze klanten om een onberispelijke service te garanderen.'
  },
  ourTeam: {
    title: 'Ons Team',
    description: 'Bij TaxiMoove is ons team onze grootste troef. Samengesteld uit gepassioneerde en ervaren professionals, deelt elk lid dezelfde visie: u een uitzonderlijke transportervaring bieden. Ontdek de mensen die elke dag werken om van uw reis een aangenaam en zorgeloos moment te maken.',
    values: {
      title: 'Onze teamwaarden',
      subtitle: 'Ons team deelt fundamentele waarden die onze acties en onze dagelijkse service leiden.',
      excellency: {
        title: 'Uitmuntendheid',
        content: 'Elk lid van ons team zet zich in om uitstekende service te leveren en de verwachtingen van klanten bij elke rit te overtreffen.'
      },
      professional: {
        title: 'Professionaliteit',
        content: 'Onze chauffeurs en administratief personeel tonen onberispelijke professionaliteit in al hun interacties.'
      },
      cohesion: {
        title: 'Teamgeest',
        content: 'We werken samen, in synergie, om een soepele en gecoördineerde ervaring voor al onze klanten te garanderen.'
      }
    }
  },
  transport: {
    standard: {
      title: 'Standaard Transport',
      description: 'Onze standaard transportservice is ontworpen om te voldoen aan al uw dagelijkse reisbehoeften met een superieur niveau van service en comfort. Of het nu gaat om een zakelijke reis, een belangrijke afspraak of een avondje uit in de stad, wij garanderen u een onberispelijke ervaring.',
      values: {
        quality: {
          title: 'Comfort en Kwaliteit',
          content: 'Al onze voertuigen zijn recent, voorzien van airconditioning en perfect onderhouden om u optimaal comfort te garanderen. Onze hoffelijke en professionele chauffeurs staan tot uw dienst om uw reis aangenaam te maken.'
        },
        reservation: {
          title: 'Eenvoudig Reserveren',
          content: 'Boek uw rit met slechts een paar klikken via onze website of mobiele app. U kunt ons ook telefonisch contacteren voor een onmiddellijke of toekomstige reservering.'
        },
        available: {
          title: 'Beschikbaarheid',
          content: 'Onze service is 24/7 beschikbaar om te voldoen aan al uw transportbehoeften, ongeacht het tijdstip of de dag. U kunt altijd op ons rekenen.'
        },
      },
      footer: {
        title: 'Goed om te Weten',
        content: 'Voor onze vaste klanten bieden wij voordelige abonnementsformules aan. Neem contact met ons op voor meer informatie over onze gepersonaliseerde aanbiedingen voor particulieren en bedrijven.'
      }
    },
    airport: {
      title: 'Luchthaven & Station Transfers',
      description: 'Onze luchthaven- en stationtransferservice biedt u een betrouwbare en comfortabele oplossing voor al uw verplaatsingen van en naar de belangrijkste transportinfrastructuren in België. Wij volgen uw vlucht of trein op en passen onze service daarop aan.',
      airport: {
        title: 'Bediende luchthavens',
        subtitle: 'Wij verzorgen transfers van en naar alle belangrijke Belgische luchthavens:',
        bru: 'Luchthaven Brussel (BRU)',
        crl: 'Luchthaven Charleroi (CRL)',
        anvers: 'Luchthaven Antwerpen',
        ostende: 'Luchthaven Oostende-Brugge',
        lgg: 'Luchthaven Luik (LGG)'
      },
      station: {
        title: 'Bediende stations',
        subtitle: 'Wij verzorgen ook transfers van en naar de belangrijkste treinstations in België:',
        bruMidi: 'Station Brussel-Zuid',
        bruCentral: 'Station Brussel-Centraal',
        bruNorth: 'Station Brussel-Noord',
        anvers: 'Station Antwerpen-Centraal',
        gand: 'Station Gent-Sint-Pieters',
        louvain: 'Station Leuven',
        malines: 'Station Mechelen',
        bruges: 'Station Brugge'
      },
      values: {
        track: {
          title: 'Real-time tracking',
          content: 'Wij volgen de status van uw vlucht of trein in real-time om ons aan te passen aan eventuele vertragingen zonder extra kosten. Uw chauffeur zal op u wachten, zelfs bij aanzienlijke vertragingen.'
        },
        reservation: {
          title: 'Vooraf reserveren',
          content: 'Reserveer uw transfer vooraf om uw ophaling te garanderen. Geef gewoon uw vlucht- of treinnummer op en wij zorgen voor de rest.'
        }
      },
      footer: {
        title: 'Belangrijk',
        content: 'Voor luchthavenstransfers raden wij aan om minstens 24 uur vooraf te reserveren. Voor internationale aankomsten wacht uw chauffeur op u bij de uitgang van de bagageafhalingzone met een bord met uw naam.'
      }
    },
    parcel: {
      title: 'Pakket Transfer',
      description: [
        'Onze pakket transfer service biedt u een snelle, betrouwbare en veilige oplossing voor het bezorgen van uw pakketten en belangrijke documenten. Ideaal voor bedrijven en particulieren die een express bezorgservice nodig hebben.',
        'Met TaxiMoove profiteert u van een gepersonaliseerde service, real-time tracking en zorgvuldige behandeling van uw zendingen. Ons team van ervaren chauffeurs zet zich in om de kortst mogelijke deadlines na te komen om aan uw behoeften te voldoen.'
      ],
      features: {
        express: {
          title: 'Express Bezorging',
          content: 'Wij garanderen een snelle bezorgservice voor al uw urgente pakketten en documenten. Ons team zet zich in om de kortst mogelijke deadlines na te komen om aan uw behoeften te voldoen.'
        },
        security: {
          title: 'Maximale Veiligheid',
          content: 'Uw pakketten worden met de grootste zorg behandeld door onze getrainde chauffeurs. Wij zorgen voor volledige traceerbaarheid en real-time tracking van uw zending.'
        },
        speed: {
          title: 'Snelle Service',
          content: 'Onze service is 24/7 beschikbaar om aan uw urgente behoeften te voldoen. Boek online of telefonisch voor onmiddellijke ophaling.'
        },
        personalized: {
          title: 'Gepersonaliseerde Service',
          content: 'Wij passen onze service aan uw specifieke behoeften aan, of het nu gaat om grote, breekbare pakketten of pakketten die speciale transportvoorwaarden vereisen.'
        },
        region: {
          title: 'Volledige Dekking',
          content: 'Service beschikbaar in de hele Brusselse regio en in Vlaanderen. Wij zorgen voor punctuele en betrouwbare leveringen op bestemming.'
        },
        tracking: {
          title: 'Real-Time Tracking',
          content: 'Volg de status van uw bezorging in real-time dankzij ons traceerbaarheidsysteem. Ontvang meldingen bij elke fase van uw zending.'
        }
      },
      footer: {
        title: 'Belangrijk',
        content: [
          'Om een optimale service te garanderen, raden wij u aan om:',
          [
            'Uw pakketten correct in te pakken voor transport',
            'Nauwkeurige informatie over de inhoud te verstrekken',
            'Het bezorgadres duidelijk aan te geven',
            'Een beschikbaar contactpersoon op het bezorgadres te regelen'
          ],
          'Voor bedrijven die regelmatig zendingen doen, bieden wij voordelige maandpakketten aan. Neem contact met ons op voor een gepersonaliseerd aanbod aangepast aan uw zendingsvolume.'
        ]
      }
    }
  },
  contact: {
    title: 'Neem contact met ons op',
    subtitle: 'Wij staan klaar om naar al uw vragen te luisteren',
    name: {
      label: 'Volledige naam',
      placeholder: 'Uw naam'
    },
    email: {
      label: 'Email',
      placeholder: 'Uw email'
    },
    phone: {
      label: 'Telefoon',
      placeholder: 'Uw telefoon'
    },
    subject: {
      label: 'Onderwerp',
      placeholder: 'Onderwerp van uw bericht'
    },
    message: {
      label: 'Bericht',
      placeholder: 'Uw bericht'
    },
    action: {
      submitting: 'Verzenden...',
      submit: 'Bericht verzenden'
    },
    success: 'Uw bericht is succesvol verzonden. Wij zullen zo spoedig mogelijk op u reageren.'
  },
  becomeDriver: {
    title: 'Word een TaxiMoove Chauffeur',
    description: 'Sluit je aan bij ons team van professionele chauffeurs en geniet van een flexibele carrière met aantrekkelijke inkomsten. Bij TaxiMoove waarderen we professionaliteit en service excellentie.',
    requirements: {
      vehicle: {
        title: 'Eigen Voertuig',
        content: 'Bezit een eigen voertuig in uitstekende staat, recent en goed onderhouden. Het voertuig moet voldoen aan onze kwaliteits- en comfortcriteria.'
      },
      experience: {
        title: 'Professionele Ervaring',
        content: 'Heb minstens 2 jaar professionele rijervaring. Ervaring in personenvervoer is een pre.'
      },
      documents: {
        title: 'Rijbewijs en Documenten',
        content: 'Bezit een geldig rijbewijs voor meer dan 3 jaar. Geen strafblad en schoon uittreksel strafregister.'
      },
    },
    benefits: {
      title: 'De Voordelen van TaxiMoove',
      money: {
        title: 'Aantrekkelijke Inkomsten',
        content: 'Geniet van competitieve inkomsten met bonussen en fooien. Verdien meer door te werken tijdens piekuren.'
      },
      flexibility: {
        title: 'Volledige Flexibiliteit',
        content: 'Beheer je schema zoals je wilt. Kies je werkuren en werkgebieden.'
      },
      support: {
        title: 'Continue Ondersteuning',
        content: 'Profiteer van 24/7 technische en administratieve ondersteuning. Continue training en groeimogelijkheden.'
      },
    },
    apply: 'Nu Solliciteren'
  },
  search: {
    services: {
      transport: 'Transport',
      transfer: 'Transfer',
      parcel: 'Pakket'
    },
    vehicles: {
      economy: 'Economie',
      standard: 'Standaard',
      van: 'Bestelwagen'
    },
    capacity: 'personen',
    origin: {
      label: 'Vertrek',
      placeholder: 'Vertrekadres'
    },
    destination: {
      label: 'Bestemming',
      placeholder: 'Aankomstadres'
    },
    startDate: 'Vertrekdatum',
    startTime: 'Vertrektijd',
    returnDate: 'Retourdatum',
    returnTime: 'Retourtijd',
    flightNumber: 'Vluchtnummer',
    nametag: 'Naamkaartje',
    weight: 'Gewicht',
    dimensions: 'Afmetingen',
    description: {
      label: 'Beschrijving',
      placeholder: 'Pakketbeschrijving'
    },
    distance: 'Afstand',
    duration: 'Duur',
    error: {
      noDataFound: 'Geen reisinformatie gevonden. Voer een nieuwe zoekopdracht uit.',
      noSelectedVehicle: 'Selecteer een voertuig om door te gaan.'
    },
    action: {
      addReturn: 'RETOUR TOEVOEGEN',
      loading: 'Laden...',
      book: 'Nu boeken'
    }
  },
  payment: {
    title: 'Veilige betaling',
    name: 'Naam op kaart',
    phone: 'Telefoon',
    card: 'Kaartgegevens',
    action: {
      processing: 'Verwerken...',
      pay: 'Betalen',
      loading: 'Laden...',
      return: 'Terug'
    },
    success: 'Betaling succesvol! Doorsturen...',
    notice: 'Veilige betaling met Stripe. Uw kaartgegevens zijn versleuteld.',
    error: {
      noDataFound: 'Geen boekingsinformatie gevonden. Voer een nieuwe zoekopdracht uit.'
    },
    summary: 'Besteloverzicht',
    services: {
      label: 'Service',
      transport: 'Transport',
      transfer: 'Transfer',
      parcel: 'Pakket'
    },
    vehicle: 'Voertuig',
    itinerary: 'Route',
    date: 'Datum',
    return: 'Retour',
    flightNumber: 'Vluchtnummer',
    weight: 'Gewicht',
    dimensions: 'Afmetingen',
    description: 'Beschrijving',
    total: 'Totaal',
    secure: 'Veilige betaling',
    methods: {
      select: 'Betaalmethode',
      card: 'Bankkaart',
      paypal: 'Paypal',
      bancontact: 'Bancontact'
    }
  },
  paymentReturn: {
    redirect: 'Automatische doorverwijzing binnen enkele seconden...',
    retry: 'Opnieuw proberen',
    goHome: 'Terug naar home',
    status: {
      success: 'Betaling Geslaagd',
      error: 'Betalingsfout',
      processing: 'Wordt Verwerkt'
    },
    statusDesc: {
      success: 'Uw betaling is succesvol verwerkt. Uw bestelling wordt verwerkt...',
      error: 'Betalingsfout',
      processing: 'Uw betaling wordt verwerkt. Een moment geduld...'
    },
    errors: {
      general: 'Er is een fout opgetreden bij het verifiëren van de betaling.',
      canceled: 'De betaling is geannuleerd. U kunt het opnieuw proberen indien gewenst.',
      requiresPaymentMethod: 'Uw betaling kon niet worden verwerkt. Probeer het met een andere betaalmethode.',
      unknown: 'De betalingsstatus is onbekend. Neem indien nodig contact op met de ondersteuning.'
    }
  },
  paymentSuccess: {
    title: 'Betaling Bevestigd',
    subtitle: 'Bedankt voor uw boeking!',
    confirmationCode: 'Uw bevestigingscode is:',
    details: {
      title: 'Uw boekingsgegevens'
    },
    price: 'Betaald bedrag',
    instructionsTitle: 'Wat gebeurt er nu?',
    instructions: [
      'Een bevestigingse-mail is naar uw adres verzonden.',
      'Ons team zal contact met u opnemen om uw boekingsgegevens te bevestigen.',
      'Voor vragen kunt u gerust contact met ons opnemen.'
    ],
    returnHome: 'Terug naar home',
    contactUs: 'Contact opnemen'
  },
  profile: {
    accountInfo: 'Accountinformatie',
    editProfile: 'Profiel bewerken',
    savedAddresses: 'Opgeslagen adressen',
    paymentMethods: 'Betaalmethoden',
    security: 'Beveiliging',
    changePassword: 'Wachtwoord wijzigen',
    twoFactorAuth: 'Tweefactorauthenticatie',
    preferences: 'Voorkeuren',
    language: 'Taal',
    appearance: 'Uiterlijk',
    silentRide: 'Stille rit',
    petFriendly: 'Rit met huisdier',
    notifications: 'Meldingen',
    other: 'Overig',
    referral: 'Doorverwijzing',
    legal: 'Juridische informatie',
    logout: 'Uitloggen',
    title: 'Mijn profiel',
    theme: 'Thema',
    help: 'Hulp en Ondersteuning'
  },
  password: {
    title: 'Wachtwoord wijzigen',
    current: 'Huidig wachtwoord',
    new: 'Nieuw wachtwoord',
    confirm: 'Wachtwoord bevestigen',
    change: 'Wachtwoord wijzigen',
    mismatch: 'Wachtwoorden komen niet overeen',
    tooShort: 'Wachtwoord moet minimaal 8 karakters bevatten',
    changeError: 'Fout bij het wijzigen van het wachtwoord',
    changeSuccess: 'Wachtwoord succesvol gewijzigd'
  },
  language: {
    title: 'Taal kiezen',
    french: 'Frans',
    english: 'Engels'
  },
  theme: {
    title: 'Thema kiezen',
    light: 'Licht',
    dark: 'Donker'
  },
  referral: {
    title: 'Doorverwijzingsprogramma',
    yourCode: 'Uw doorverwijzingscode',
    description: 'Deel uw doorverwijzingscode met uw vrienden en verdien beloningen!',
    copy: 'Kopiëren',
    copied: 'Gekopieerd!',
    referrals: 'Doorverwijzingen',
    earned: 'Verdiend',
    pending: 'In behandeling'
  },
  legal: {
    title: 'Juridische informatie',
    terms: {
      title: 'Algemene voorwaarden',
      lastUpdated: 'Laatst bijgewerkt: 1 maart 2024',
      intro: 'Door gebruik te maken van onze service accepteert u de volgende voorwaarden:',
      terms1: 'U moet minimaal 18 jaar oud zijn om deze service te gebruiken',
      terms2: 'U bent verantwoordelijk voor de vertrouwelijkheid van uw account',
      terms3: 'Wij behouden ons het recht voor om deze voorwaarden op elk moment te wijzigen'
    },
    privacy: {
      title: 'Privacybeleid',
      intro: 'Wij nemen de bescherming van uw persoonlijke gegevens zeer serieus.',
      points1: 'Wij verzamelen alleen gegevens die nodig zijn voor de werking van de service',
      points2: 'Uw gegevens worden nooit verkocht aan derden',
      points3: 'U kunt op elk moment verwijdering van uw gegevens aanvragen'
    },
    cookies: {
      title: 'Cookiebeleid',
      intro: 'Wij gebruiken cookies om uw ervaring te verbeteren.',
      types1: 'Essentiële cookies voor de werking van de website',
      types2: 'Analytische cookies om onze services te verbeteren',
      types3: 'Voorkeurscookies om uw keuzes op te slaan'
    },
    contact: {
      title: 'Contact',
      email: 'Email: contact@taximoove.com',
      address: 'Adres: 123 rue de la Paix, 75000 Parijs',
      phone: 'Telefoon: +33 1 23 45 67 89'
    }
  },
  help: {
    title: 'Hulp en Ondersteuning',
    chat: {
      title: 'Live chat',
      description: 'Chat in realtime met ons ondersteuningsteam',
      welcome: 'Hallo! Hoe kunnen we u vandaag helpen?',
      placeholder: 'Typ uw bericht...',
      autoResponse: 'Bedankt voor uw bericht. Een lid van ons team zal u binnen enkele ogenblikken antwoorden.'
    },
    phone: {
      title: 'Telefonische ondersteuning',
      description: 'Bel ons voor directe assistentie',
      hours: 'Maandag - Vrijdag: 9:00 - 18:00',
      availability: 'Beschikbaar in Frankrijk en internationaal'
    },
    email: {
      title: 'Email ondersteuning',
      description: 'Stuur ons een email en wij antwoorden zo snel mogelijk',
      subject: 'Onderwerp',
      subjectPlaceholder: 'Voer het onderwerp van uw bericht in',
      message: 'Bericht',
      messagePlaceholder: 'Beschrijf uw verzoek in detail',
      send: 'Verzenden'
    },
    faq: {
      title: 'Veelgestelde vragen',
      searchPlaceholder: 'Zoeken in FAQ...',
      questions: {
        q1: 'Hoe reserveer ik een rit?',
        q2: 'Hoe wijzig ik een reservering?',
        q3: 'Welke betaalmethoden worden geaccepteerd?',
        q4: 'Hoe annuleer ik een reservering?',
        q5: 'Hoe word ik chauffeur?'
      },
      answers: {
        a1: 'Om een rit te reserveren, log in op uw account, selecteer uw vertrek- en aankomstpunt, kies uw voertuig en bevestig de reservering.',
        a2: 'U kunt uw reservering wijzigen tot 1 uur voor de rit door naar de sectie "Mijn ritten" van uw account te gaan.',
        a3: 'Wij accepteren bankkaarten (Visa, Mastercard, American Express), PayPal en bankoverschrijvingen.',
        a4: 'Om een reservering te annuleren, ga naar de sectie "Mijn ritten", selecteer de betreffende rit en klik op "Annuleren".',
        a5: 'Om chauffeur te worden, vul het registratieformulier in bij de sectie "Chauffeur worden" en dien de vereiste documenten in.'
      }
    }
  },
  footer: {
    about: {
      title: 'Over ons',
      ourStory: 'Ons verhaal',
      ourVehicles: 'Ons wagenpark',
      ourTeam: 'Ons team',
      contact: 'Contact opnemen',
    },
    services: {
      title: 'Diensten',
      standard: 'Standaard Transport',
      airport: 'Luchthaven Transfers',
      parcel: 'Pakketbezorging',
    },
    contact: {
      title: 'Contact',
      email: 'Email',
      phone: 'Telefoon'
    },
    join: {
      title: 'Sluit je bij ons aan',
      becomeDriver: 'Chauffeur worden'
    },
    copyright: {
      allRightsReserved: 'Alle rechten voorbehouden.',
      mentions: 'Juridische vermeldingen',
      terms: 'Algemene voorwaarden',
      confidentiality: 'Privacybeleid'
    }
  }
}; 